<div mat-dialog-title class="row">
    <div class="dialog-title">
       <h5> Comments History </h5>
     <button type="button" class="close" aria-label="Close"  justify-content= "flex-end" (click)="closeDialog(true)">
        <span aria-hidden="true">&times;</span>
      </button> 
    </div>
</div>
  <mat-dialog-content>
   <div class= "dialog-content">
        <ul>
            <li *ngFor="let comments of commentHistoryList">
                <p>Stage - {{comments.stage}} 
                    <span>(</span> 
                     {{comments.createdOn | date: 'MM-dd-yyyy hh:mm'}}
                     <span>)</span>
                </p>
                <p>{{comments.comments}}</p>
            </li>
        </ul>
        <p *ngIf="commentHistoryList.length === 0">Comments not started</p>
   </div>
   <div *ngIf = "showAddCommentTextArea" class = "add-comment-container">
        <input type="text" class="input-field" [(ngModel)] = "commentsEntered" placeholder="Enter Comments">
        <span> <i class='fas fa-arrow-alt-circle-right' style= 'margin-left: auto;
            color: black; size: 50px;' (click)="submitComments()"></i></span>
    </div>
<mat-dialog-content>
  <div mat-dialog-actions class="dialog-footer">
    <button type="button"
      class="custom_btn primary_btn_base" (click)= "onAddCommentClick()">Add Commnets</button>
  </div>